import { isNullOrUndefined } from "./validateObject";

/**
 * Genera un filterMethod case-insensitive para columnas de ReactTable.
 * Compara el valor de la fila (en el accessor indicado) contra el texto
 * ingresado, ignorando mayúsculas/minúsculas y tolerando valores nulos.
 *
 * @param {String} accessor - Llave de la fila a filtrar (ej. "name").
 * @returns {Function} filterMethod(filter, row) => boolean
 */
export const textFilter = (accessor) => (filter, row) => {
  const cellValue = row?.[accessor];
  if (isNullOrUndefined(cellValue)) return false;
  return String(cellValue)
    .toLowerCase()
    .includes(String(filter.value).toLowerCase());
};
